import { __ } from '@wordpress/i18n';

/**
 * Get status
 * @param {boolean} confirmed
 * @param {boolean} joinable
 * @returns {JSX.Element}
 */
const CourseListItemClosingSoon = ({ start }) => {
	const currentDate = new Date();
	const startDate = new Date(start);
	const registrationClosingSoon =
		startDate > currentDate &&
		startDate < currentDate.setMonth(currentDate.getMonth() + 2); // One month from now

	if (!registrationClosingSoon) {
		return null;
	}

	return (
		<div className="course-list__item__content-closing-soon">
			{__('Registration closing soon', 'kotisivu-block-theme')}
		</div>
	);
};

export default CourseListItemClosingSoon;
